import { createReducer } from 'services/reduxHelpers'
import { userTypes } from 'reduxModules/actions/UserActions'

/* ------------- Initial State ------------- */

export const initialState = {
  uid: null,
  role: null,
  email: null,
  name: null,
  lineId: null,
  company: '',
  history: [],
  users: [],
  isLoading: false
}

/* ------------- Hookup Reducers To Types ------------- */

export default createReducer(initialState, {
  [userTypes.GET_USER_DATA_SUCCESS]: (_, { data }) => ({
    ...data
  }),

  [userTypes.CLEAR_USER_DATA_ATTEMPT]: () => ({
    ...initialState
  }),

  [userTypes.GET_USERS_ATTEMPT]: () => ({
    isLoading: true
  }),
  [userTypes.GET_USERS_SUCCESS]: (_, { data }) => ({
    users: data,
    isLoading: false
  }),
  [userTypes.GET_USERS_FAILURE]: () => ({
    isLoading: false
  }),

  [userTypes.GET_USER_HISTORY_ATTEMPT]: () => ({
    history: [],
  }),
  [userTypes.GET_USER_HISTORY_SUCCESS]: (_, { data }) => ({
    history: data,
  }),

  [userTypes.CREATE_USER_ATTEMPT]: () => ({
    isLoading: true
  }),
  [userTypes.CREATE_USER_SUCCESS]: () => ({
    isLoading: false
  }),
  [userTypes.CREATE_USER_FAILURE]: () => ({
    isLoading: false
  }),

  [userTypes.DELETE_USER_ATTEMPT]: () => ({
    isLoading: true
  }),
  [userTypes.DELETE_USER_SUCCESS]: ({ users }, { data: { uid } }) => ({
    users: users.filter(({ id }) => id !== uid),
    isLoading: false
  }),
  [userTypes.DELETE_USER_FAILURE]: () => ({
    isLoading: false
  }),

  [userTypes.SET_USER_LINE_ID_SUCCESS]: ({ users }, { data: { uid, lineId } }) => ({
    users: users.map(user => {
      if (user.id === uid) {
        return {
          ...user,
          lineId
        }
      }
      return user
    })
  }),
})



// WEBPACK FOOTER //
// ./src/reduxModules/reducers/UserReducer.js